export default __webpack_public_path__ + "static/media/file-delete.b01d6e0c.svg";